import React, { Component } from "react";
import styles from "./reportContructor.module.scss";

import { withReportsList } from "../../../shared/containers/containerReportsList";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";

import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import { Input } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";

class ReportCharFieldsConstructorItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTitleEditing: false,
      title: null,
    };
  }

  onSelectToChange() {
    const { field, onSelectHandle } = this.props;
    onSelectHandle(field);
  }

  onUpdate() {
    const { onUpdateHandler } = this.props;

    onUpdateHandler();
  }

  onChangeTitle(value) {
    this.setState({ title: value });
  }

  onDelete() {
    const { onDeleteCustomReportField, selectedCustomReportId, field } = this.props;
    onDeleteCustomReportField({ id: field.id }, selectedCustomReportId);
  }

  onUpdateTitle() {
    const { onUpdateCustomReportField, selectedCustomReportId, field } = this.props;
    const { selectedField, title } = this.state;

    if (selectedField !== null) {
      const options = {
        id: field.id,
        title: title,
        excelColumnWidth: 2,
        cssColumnWidth: 2,
      };

      onUpdateCustomReportField(options, selectedCustomReportId);
    }
  }

  render() {
    const { field, isSelect, cssColumnWidth } = this.props;
    const { title, isTitleEditing } = this.state;

    if (isTitleEditing) {
      return (
        <div className={styles.dashboardsItemContainer}>
          <Input
            fontSize="small"
            name="dashboardTitle"
            type="text"
            onChange={(e) => {
              this.onChangeTitle(e.target.value);
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
            defaultValue={title ?? field.dashboard.title}
            fullWidth={false}
            style={{ fontSize: "11px", width: "85%" }}
          />

          <div className={styles.dashboardsItemRightContainer}>
            <TooltipWrapper title={`Созранить наименование`} position="top">
              <SaveIcon
                fontSize="small"
                className={styles.reportTitleEditButton}
                onClick={(e) => {
                  e.stopPropagation();
                  this.onUpdateTitle();
                }}
              />
            </TooltipWrapper>
          </div>
        </div>
      );
    }

    return (
      <div
        style={{ width: `${cssColumnWidth}px`, backgroundColor: isSelect ? "#408ad4" : "white", cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          this.onSelectToChange();
        }}
      >
        <div className={styles.dashboardsItemContainer} style={{ position: "relative", display: "flex", alignItems: "center" }}>
          {field.dashboard.title}{" "}
          {field.dashboard.measure !== null && field.dashboard.measure !== "" ? `(${field.dashboard.measure})` : null}
          {isSelect ? (
            <div style={{ position: "absolute", right: "5px", fontSize: "14px", paddingTop: "5px" }}>
              <TooltipWrapper title={`Изменить наименование `} position="top">
                <EditIcon
                  fontSize="inherit"
                  className={styles.reportTitleEditButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({ isTitleEditing: true });
                  }}
                />
              </TooltipWrapper>

              <TooltipWrapper title={`Удалить ${field.dashboard.title}`} position="top">
                <DeleteOutlineIcon
                  fontSize="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onDelete();
                  }}
                />
              </TooltipWrapper>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportCharFieldsConstructorItem)));
